import { render } from "./Pathways.vue?vue&type=template&id=64188d34"
import script from "./Pathways.vue?vue&type=script&lang=js"
export * from "./Pathways.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/Pathways.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64188d34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64188d34', __exports__)) {
    api.reload('64188d34', __exports__)
  }
  
  module.hot.accept("./Pathways.vue?vue&type=template&id=64188d34", () => {
    api.rerender('64188d34', render)
  })

}


export default __exports__